import React from 'react';
import {
  FaHandHoldingHeart,
  FaClipboardList,
  FaChartLine,
  FaIndustry,
  FaLightbulb,
  FaFileSignature,
  FaCertificate,
  FaMicrochip,
  
  FaGlobeAsia,
  FaGlobe,
  FaHandshake,
  FaChalkboardTeacher,
  FaNetworkWired,
  FaMicrochip as FaMicrochipIcon,
  FaRobot,
  FaSolarPanel,
  FaTractor ,
   FaTools,
 
  FaUsers,


  FaIdCard,
 
  FaUserGraduate,
  
} from 'react-icons/fa';

import Footer from '../component/Footer';
import Navbar from '../component/Navbar';
import HeadingWithWatermark from '../component/HeadingWithWatermark';

// Theme colors
const primaryBlue = 'rgb(43, 147, 208)';
const yellowAccent = '#fbbf24';

// Sample data for 9 MSME schemes with icons

const schemes = [
  {
    id: 1,
    title: 'PM Vishwakarma',
    fullTitle: 'PM Vishwakarma MSMEs Scheme',
    description: 'Support for traditional artisans, craftsmen, and micro-enterprises across India.',
    icon: <FaTools className="w-6 h-6" />,
    link: 'https://pmvishwakarma.gov.in/',
  },
  {
    id: 2,
    title: 'CHAMPIONS',
    fullTitle: 'MSME Champion Scheme & Portal',
    description: 'Platform for grievance resolution, redressal, and support for MSMEs.',
    icon: <FaClipboardList className="w-6 h-6" />,
    link: 'https://champions.gov.in/',
  },
  {
    id: 3,
    title: 'e-Participation',
    fullTitle: 'PMEGP e-Participation',
    description: 'Official initiative ensuring no private agents or middlemen are involved in PMEGP assistance.',
    icon: <FaUsers className="w-6 h-6" />,
    link: 'https://www.kviconline.gov.in/pmegpeportal/pmegphome/index.jsp',
  },
  {
    id: 4,
    title: 'My MSME',
    fullTitle: 'My MSMEs Portal',
    description: 'Comprehensive platform supporting the growth of MSME sector in India.',
    icon: <FaIndustry className="w-6 h-6" />,
    link: 'https://my.msme.gov.in/',
  },
  {
    id: 5,
    title: 'PMEGP Portal',
    fullTitle: 'Prime Minister Employment Generation Programme Portal',
    description: 'Online portal for PMEGP applications with no involvement of private agencies.',
    icon: <FaGlobeAsia className="w-6 h-6" />,
    link: 'https://www.kviconline.gov.in/pmegpeportal/pmegphome/home.jsp',
  },
  {
    id: 6,
    title: 'Udyam',
    fullTitle: 'Udyam Registration Portal',
    description: 'Official government portal for MSME registration with no third-party involvement.',
    icon: <FaIdCard className="w-6 h-6" />,
    link: 'https://udyamregistration.gov.in/',
  },
  {
    id: 7,
    title: 'ASPIRE',
    fullTitle: 'ASPIRE Scheme',
    description: 'Supports livelihood business incubation and entrepreneurship development.',
    icon: <FaLightbulb className="w-6 h-6" />,
    link: 'https://msme.gov.in/schemes/aspire-scheme-promoting-innovation-rural-industry-entrepreneurship',
  },
  {
    id: 8,
    title: 'ESDP',
    fullTitle: 'Entrepreneurship and Skill Development Programs',
    description: 'Training programs for youth to promote self-employment and entrepreneurship.',
    icon: <FaUserGraduate className="w-6 h-6" />,
    link: 'https://msme.gov.in/entrepreneurship-and-skill-development-programmes',
  },
  {
    id: 9,
    title: 'SFURTI',
    fullTitle: 'Scheme of Fund for Regeneration of Traditional Industries',
    description: 'Cluster development for artisans with technology upgradation and market support.',
    icon: <FaChartLine className="w-6 h-6" />,
    link: 'https://sfurti.msme.gov.in/',
  },
];

const MSMESchemesTheme = () => {
  return (
    <>
      <Navbar/>
       <div className="min-h-screen bg-white">
      {/* Header with primary blue */}
  

      {/* Hero Section with primary blue gradient + yellow accent */}
   

      {/* WASME Legacy Section - Professional overview from brochure */}
     

      {/* Schemes Grid */}
      <section className="max-w-7xl mx-auto px-4 mt-8 sm:px-6 lg:px-8 pb-20">
        <div className="text-center mb-12">
            <HeadingWithWatermark
          title="Schemes "
          watermarkText="MSMEs"
          color="#1b73a7"                                                                
          align="center"
        />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
           Various Schemes and Programmes of Government of India , Ministry of MSMEs for Promotion Development of MSMEs in India
Role of Wasme Implementation And make Indians MSMEs aware.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {schemes.map((scheme) => (
            <div
              key={scheme.id}
              className="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 flex flex-col transform hover:-translate-y-1"
            >
              {/* Top bar with primary blue */}
              <div className="h-2" style={{ backgroundColor: primaryBlue }}></div>
              <div className="p-6 flex-1">
                <div className="flex items-center justify-between mb-4">
                  <div
                    className="p-3 rounded-xl text-white shadow-lg"
                    style={{ backgroundColor: primaryBlue }}
                  >
                    {scheme.icon}
                  </div>
                  <span
                    className="text-xs font-semibold px-3 py-1 rounded-full"
                    style={{
                      backgroundColor: yellowAccent,
                      color: '#1e3a8a', // dark blue for contrast
                    }}
                  >
                    Wasme Supported
                  </span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-1">{scheme.title}</h3>
                <p className="text-sm text-gray-500 mb-2">{scheme.fullTitle}</p>
                <p className="text-gray-600 text-sm mb-4">{scheme.description}</p>
                <a
                  href={scheme.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center w-full text-white font-medium px-5 py-3 rounded-xl hover:opacity-90 transition-opacity duration-200 text-sm shadow-md"
                  style={{ backgroundColor: primaryBlue }}
                >
                  Read More
                  <svg
                    className="w-4 h-4 ml-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>
 <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">WASME's Global Legacy & Expertise</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Over 45 years of fostering international cooperation for MSME development.
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
          {/* Top accent bar */}
          <div className="h-2" style={{ backgroundColor: primaryBlue }}></div>

          <div className="p-8 md:p-10">
            {/* Lead paragraph with 45-year highlight */}
            <div className="flex flex-col md:flex-row gap-8 items-start mb-10">
              <div className="md:w-2/3">
                <p className="text-lg text-gray-700 leading-relaxed">
                  <span className="font-bold text-[rgb(43,147,208)]">
                    In the last 45 years of WASME's existence,
                  </span>{' '}
                  it has become one of the leading international organizations working to promote and
                  develop MSMEs globally, with robust cross-border, transnational, and inter-regional
                  cooperation with all of our Members, Associates, and Partners.
                </p>
              </div>
              <div className="md:w-1/3 flex justify-center md:justify-end">
                <div className="inline-flex items-center gap-2 bg-blue-50 px-5 py-3 rounded-full">
                  <FaGlobe className="text-[rgb(43,147,208)] text-xl" />
                  <span className="font-semibold text-gray-800">45+ Years</span>
                </div>
              </div>
            </div>

            {/* Key areas of cooperation - grid of 4 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
              {[
                {
                  icon: <FaHandshake />,
                  title: 'Global Partnerships',
                  desc: 'Local Govt Bodies, Regional Authorities, Financial Institutions, International Organizations',
                },
                {
                  icon: <FaChalkboardTeacher />,
                  title: 'Knowledge & Advocacy',
                  desc: 'Conferences, Seminars, Trainings, Publications, Policy Advocacy',
                },
                {
                  icon: <FaNetworkWired />,
                  title: 'Trade Facilitation',
                  desc: 'Buyer-Seller Meets, Exhibitions, Network Linkages',
                },
                {
                  icon: <FaMicrochipIcon />,
                  title: 'End-to-End Solutions',
                  desc: 'Technology, Skill Development, Credit & Market Linkages',
                },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="bg-gray-50 p-5 rounded-xl border border-gray-200 hover:shadow-md transition"
                >
                  <div
                    className="w-10 h-10 rounded-lg flex items-center justify-center mb-3"
                    style={{ backgroundColor: primaryBlue, color: 'white' }}
                  >
                    {item.icon}
                  </div>
                  <h3 className="font-semibold text-gray-900 mb-1">{item.title}</h3>
                  <p className="text-sm text-gray-600">{item.desc}</p>
                </div>
              ))}
            </div>

            {/* Industries supported - with tag cloud */}
           

            {/* Footer note linking back to scheme support */}
           
          </div>
        </div>
      </section>
      {/* Footer */}
   <Footer/>
    </div>
    </>
   
  );
};

export default MSMESchemesTheme;